import styled from 'styled-components';

export const CanvasSpace = styled.div`
  width: 100%;
  height: 100%;
`;
